import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {RitornoPaginazione} from "../../shared/models/RitornoPaginazione";
import {Lavorazione} from "../Models/lavorazione";
import {ClassicType} from "../../shared/models/ClassicType";
import {Intervento} from "../../Interventi/Models/Intervento";
import {Progetto} from "../../Progetti/Models/Progetto";
import {ApiRestService} from "./api-rest.service";

@Injectable({
  providedIn: 'root'
})
export class LavorazioniStoreService {
  constructor(private apiRestService: ApiRestService) { }
  private EDITABLE = new BehaviorSubject<boolean>(false);
  private SHOW_ADD_FORM = new BehaviorSubject<boolean>(false);
  private STATI = new BehaviorSubject<ClassicType[]>([]);
  private LISTA = new BehaviorSubject<RitornoPaginazione<Lavorazione[]>>({total:0, data:[]});
  private SELECTED = new BehaviorSubject<Lavorazione>(null);
  private dataStore: {
    Editable: boolean,
    ShowAddForm: boolean,
    Stati: ClassicType[],
    Lista: RitornoPaginazione<Lavorazione[]>,
    Selected: Lavorazione,
  } = {
    Editable: false,
    ShowAddForm: false,
    Stati: [],
    Lista:{total:0, data:[]},
    Selected:null,
  }
  readonly $editable = this.EDITABLE.asObservable();
  readonly $showAddForm = this.SHOW_ADD_FORM.asObservable();
  readonly $stati = this.STATI.asObservable();
  readonly $lista = this.LISTA.asObservable();
  readonly $selected = this.SELECTED.asObservable();
  refreshEditable = () => this.EDITABLE.next(Object.assign({}, this.dataStore).Editable);
  refreshShowAddForm = () => this.SHOW_ADD_FORM.next(Object.assign({}, this.dataStore).ShowAddForm);
  refreshStati = () => this.STATI.next(Object.assign({}, this.dataStore).Stati);
  refreshLista = () => this.LISTA.next(Object.assign({}, this.dataStore).Lista);
  refreshSelected = () => this.SELECTED.next(Object.assign({}, this.dataStore).Selected);

  GetStati() {
    this.apiRestService.getStatiLavorazione().subscribe(data => {
      this.dataStore.Stati = data;
      this.refreshStati();
      return this.$stati;
    });
  }
  getListaLavorazioni(value) {
    this.apiRestService.getListaLavorazione(value)
      .subscribe(data => {
        this.dataStore.Lista = data;
        this.refreshLista();
        return this.$lista;
      })
  }
  updateSelected(value: Lavorazione) {
    this.dataStore.Selected = value;
    this.refreshSelected();
    return this.$selected;
  }
  updateEditable(value: boolean) {
    this.dataStore.Editable = value;
    this.refreshEditable();
  }
  updateAddable(value: boolean) {
    this.dataStore.ShowAddForm = value;
    this.refreshShowAddForm();
  }

}
